import { useStatefulPrismicClientMethod } from "./useStatefulPrismicClientMethod.js";
const usePrismicDocuments = (...args) => useStatefulPrismicClientMethod("get", args);
const useFirstPrismicDocument = (...args) => useStatefulPrismicClientMethod("getFirst", args);
const useAllPrismicDocumentsDangerously = (...args) => useStatefulPrismicClientMethod("dangerouslyGetAll", args);
const usePrismicDocumentByID = (...args) => useStatefulPrismicClientMethod("getByID", args);
const usePrismicDocumentsByIDs = (...args) => useStatefulPrismicClientMethod("getByIDs", args);
const useAllPrismicDocumentsByIDs = (...args) => useStatefulPrismicClientMethod("getAllByIDs", args);
const usePrismicDocumentByUID = (...args) => useStatefulPrismicClientMethod("getByUID", args);
const usePrismicDocumentsByUIDs = (...args) => useStatefulPrismicClientMethod("getByUIDs", args);
const useAllPrismicDocumentsByUIDs = (...args) => useStatefulPrismicClientMethod("getAllByUIDs", args);
const useSinglePrismicDocument = (...args) => useStatefulPrismicClientMethod("getSingle", args);
const usePrismicDocumentsByType = (...args) => useStatefulPrismicClientMethod("getByType", args);
const useAllPrismicDocumentsByType = (...args) => useStatefulPrismicClientMethod("getAllByType", args);
const usePrismicDocumentsByTag = (...args) => useStatefulPrismicClientMethod("getByTag", args);
const useAllPrismicDocumentsByTag = (...args) => useStatefulPrismicClientMethod("getAllByTag", args);
const usePrismicDocumentsBySomeTags = (...args) => useStatefulPrismicClientMethod("getBySomeTags", args);
const useAllPrismicDocumentsBySomeTags = (...args) => useStatefulPrismicClientMethod("getAllBySomeTags", args);
const usePrismicDocumentsByEveryTag = (...args) => useStatefulPrismicClientMethod("getByEveryTag", args);
const useAllPrismicDocumentsByEveryTag = (...args) => useStatefulPrismicClientMethod("getAllByEveryTag", args);
export {
  useAllPrismicDocumentsByEveryTag,
  useAllPrismicDocumentsByIDs,
  useAllPrismicDocumentsBySomeTags,
  useAllPrismicDocumentsByTag,
  useAllPrismicDocumentsByType,
  useAllPrismicDocumentsByUIDs,
  useAllPrismicDocumentsDangerously,
  useFirstPrismicDocument,
  usePrismicDocumentByID,
  usePrismicDocumentByUID,
  usePrismicDocuments,
  usePrismicDocumentsByEveryTag,
  usePrismicDocumentsByIDs,
  usePrismicDocumentsBySomeTags,
  usePrismicDocumentsByTag,
  usePrismicDocumentsByType,
  usePrismicDocumentsByUIDs,
  useSinglePrismicDocument
};
//# sourceMappingURL=clientHooks.js.map
